<template>
    <div class="label-list-box">
        <div class="label-opration">
            <el-input placeholder="请输入名称" v-model="queryParams.labelName" prefix-icon="el-icon-search"
                      style="width: 250px"></el-input>
            <el-button style="margin-left: 10px" type="danger" @click="searchLabel">搜索</el-button>
            <el-button v-if="type=='PRODUCT_LABEL'" style="float: right" type="danger" @click="syncCoinToLabel">
                同步币种生成币种标签
            </el-button>
            <el-button style="float: right" icon="el-icon-plus" type="danger" @click="openCreateLabelDialog">新建标签
            </el-button>
            <el-upload style="float: right" ref="upload" action=""
                       :auto-upload="false" :show-file-list="false" accept="xlsx,xls,csv"
                       :on-change="onFileChange">
                <el-button slot="trigger" icon="el-icon-upload" type="primary">导入标签</el-button>
            </el-upload>
        </div>
        <div class="label-list">
            <el-table class="label-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="labelList" :row-key="() => Math.random()">
                <el-table-column prop="labelName" label="标签名称" width="200px" show-overflow-tooltip></el-table-column>
                <el-table-column label="包含标签" min-width="300px">
                    <template slot-scope="scope">
                        <el-tag type="info" style="margin-right: 5px" v-for="item in scope.row.labelDetails"
                                :key="item.id">{{item.labelName}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" width="300px">
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="250px">
                    <template slot-scope="scope">
                        <el-button type="primary" icon="el-icon-edit" @click="updateLabelDialog(scope.row)">修改
                        </el-button>
                        <el-button type="danger" icon="el-icon-delete" @click="handleRemoveLabel(scope.row.id)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParams.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="queryParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="40%" @close="clearData">
            <div>
                <div v-for="lang in languages" :key="lang.value" style="margin-bottom: 10px">
                    <span>标签名称({{ lang.label }})</span>
                    <el-input :value="description[lang.value]" size="small" style="width: 70%;margin-left: 10px"
                              maxlength="200"
                              @change="handleEditorChange(lang.value, $event)"></el-input>
                    <span style="color: red" v-if="lang.value=='zh'">* 必填</span>
                </div>
                <div style="line-height: 50px;height: 50px;margin-top: 10px">
                    <div style="margin-right: 20px;float: left">包含标签:</div>
                    <el-tabs v-model="activeName" @tab-click="handleLabelClick"
                             style="width: 80%;display: inline-block">
                        <el-tab-pane label="币种标签库" name="PRODUCT_LABEL"
                                     v-if="type=='PRODUCT_LABEL' || type=='CUSTOM_LABEL'"></el-tab-pane>
                        <el-tab-pane label="人物标签库" name="PEOPLE_LABEL"
                                     v-if="type=='PEOPLE_LABEL' || type=='CUSTOM_LABEL'"></el-tab-pane>
                        <el-tab-pane label="机构标签库" name="ORGANIZATION_LABEL"
                                     v-if="type=='ORGANIZATION_LABEL' || type=='CUSTOM_LABEL'"></el-tab-pane>
                        <el-tab-pane label="项目标签库" name="PROJECT_LABEL"
                                     v-if="type=='PROJECT_LABEL' || type=='CUSTOM_LABEL'"></el-tab-pane>
                        <el-tab-pane label="类别标签库" name="CATEGORY_LABEL"
                                     v-if="type=='CATEGORY_LABEL' || type=='CUSTOM_LABEL'"></el-tab-pane>
                        <el-tab-pane label="自定义标签库" name="CUSTOM_LABEL" v-if="type=='CUSTOM_LABEL'"></el-tab-pane>
                    </el-tabs>
                </div>
                <div style="margin-top: 20px">
                    <el-input placeholder="请输入名称" v-model="query.labelName" prefix-icon="el-icon-search"
                              style="width: 80%"></el-input>
                    <el-button style="margin-left: 10px" type="danger" @click="searchDialogLabel">搜索</el-button>
                </div>
                <div style="margin-top: 20px;margin-bottom: 50px;max-height: 400px">
                    <el-tag style="margin-right: 5px;margin-bottom: 5px;cursor: pointer" v-for="item in labelListDialog"
                            :key="item.id"
                            @click.native="chooseLabel(item.id)" :type="getTagType(item.id)">
                        {{item.labelName}}
                    </el-tag>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="createLabel">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="导入标签" :visible.sync="labelDialogVisible" width="60%" @close="clearDataTwo"
                   :close-on-click-modal="false">
            <el-table class="data-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="importData" :row-key="() => Math.random()">
                <el-table-column prop="type" label="标签类型">
                    <template slot-scope="scope">
                        <span>{{type}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="zh" label="名称（中文）"></el-table-column>
                <el-table-column prop="en" label="名称（英语）"></el-table-column>
                <el-table-column prop="ja" label="名称（日语）"></el-table-column>
                <el-table-column prop="kr" label="名称（韩语）"></el-table-column>
                <el-table-column prop="ru" label="名称（俄语）"></el-table-column>
                <el-table-column prop="vi" label="名称（越南语）"></el-table-column>
            </el-table>

            <span slot="footer" class="dialog-footer">
                <el-button type="danger" :loading="loading" @click="importLabel">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import api from '../../api';
    import LANGUAGES from "../../../../common/languages_code";
    import XLSX from 'xlsx';

    export default {
        name: "labelList",
        props: {type: String},
        data() {
            return {
                labelList: [], //数据列表
                labelListDialog: [], //对话框选择标签数据列表
                total: 0, //总条数
                queryParams: { //查询参数
                    labelName: "",
                    labelType: "",
                    page: 1,
                    size: 10
                },
                query: { //对话框查询参数
                    labelName: "",
                    labelType: "",
                    page: 1,
                    size: 1000
                },
                labelData: { //标签参数
                    labelId: -1,
                    labelName: "",
                    nameJson: "",
                    labelType: "",
                    containLabelIds: ""
                },
                containLabelIds: [], //选择的标签
                dialogTitle: "", //弹框标题
                dialogVisible: false,  //弹框是否显示
                currOpration: 0,  //当前操作 0-新增，1修改
                activeName: "PRODUCT_LABEL",
                languages: Object.keys(LANGUAGES).map(lang => ({
                    label: LANGUAGES[lang],
                    value: lang
                })),
                description: {},
                importData: [],
                labelDialogVisible: false,
                loading: false,
                accept: ['xlsx', 'xls', 'csv'],
            }
        },
        mounted() {

        },
        methods: {
            initData() {
                Object.keys(LANGUAGES).map(lang => {
                    this.description[lang] = "";
                })
            },
            handleEditorChange(lang, value) {
                this.description[lang] = value;
                this.labelData.labelName = this.description["zh"];
                this.labelData.nameJson = JSON.stringify(this.description);
            },
            handleRemoveLabel(id) {
                this.$confirm('确认删除此标签吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.deleteLabel({"labelId": id}).then(({data}) => {
                        this.$message.success('删除成功！');
                        this.getLabelList(this.queryParams);
                    });
                }).catch(() => {
                });
            },
            updateLabelDialog(row) {
                this.labelData.labelId = row.id;
                this.labelData.labelName = row.labelName;
                this.labelData.nameJson = row.nameJson;
                this.labelData.labelType = row.labelType;
                this.labelData.containLabelIds = row.containLabelId;
                this.containLabelIds = row.containLabelId.split(",");
                if (row.nameJson && row.nameJson != "") {
                    this.description = JSON.parse(row.nameJson);
                }
                this.description["zh"] = row.labelName;
                this.query.labelName = "";
                this.query.labelType = this.activeName;
                this.getDialogLabelList(this.query);
                this.currOpration = 1;
                this.dialogVisible = true;
                this.dialogTitle = "修改标签";
            },
            getTagType(id) {
                id = id + "";
                return this.containLabelIds.indexOf(id) == -1 ? "info" : "danger";
            },
            chooseLabel(id) {
                id = id + "";
                this.containLabelIds.indexOf(id) == -1 ? this.containLabelIds.push(id) : this.containLabelIds.splice(this.containLabelIds.indexOf(id), 1);
            },
            searchDialogLabel() {
                this.query.labelType = this.activeName;
                this.getDialogLabelList(this.query);
            },
            createLabel() {
                if (this.labelData.labelName == "") {
                    this.$message.success('请输入标签名称！');
                    return;
                }
                this.labelData.labelType = this.type;
                this.labelData.containLabelIds = this.containLabelIds.join(",");
                if (this.currOpration == 0) {
                    api.addLabel(this.labelData).then(({data}) => {
                        this.$message.success('新建成功！');
                        this.dialogVisible = false;
                        this.getLabelList(this.queryParams);
                    });
                } else {
                    api.updateLabel(this.labelData).then(({data}) => {
                        this.$message.success('修改成功！');
                        this.dialogVisible = false;
                        this.getLabelList(this.queryParams);
                    });
                }
            },
            handleLabelClick() {
                this.query.labelName = "";
                this.query.labelType = this.activeName;
                this.getDialogLabelList(this.query);
            },
            getDialogLabelList(query) {
                api.getLabelList(query).then(({data}) => {
                    this.labelListDialog = data.records;
                });
            },
            openCreateLabelDialog() {
                this.query.labelName = "";
                this.query.labelType = this.activeName;
                this.getDialogLabelList(this.query);
                this.currOpration = 0;
                this.dialogTitle = "新建标签";
                this.dialogVisible = true;
            },
            searchLabel() {
                this.queryParams.page = 1;
                this.getLabelList(this.queryParams);
            },
            getLabelList(param) {
                api.getLabelList(param).then(({data}) => {
                    this.labelList = data.records;
                    this.total = data.total;
                });
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getLabelList(this.queryParams);
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getLabelList(this.queryParams);
            },
            clearData() {
                this.labelData = { //标签参数
                    labelId: -1,
                    labelName: "",
                    nameJson: "",
                    labelType: "",
                    containLabelIds: ""
                }
                this.query = { //对话框查询参数
                    labelName: "",
                    labelType: "",
                    page: 1,
                    size: 1000
                }
                this.containLabelIds = [];
                this.labelListDialog = [];
                this.initData();
            },
            syncCoinToLabel() {
                this.$confirm('确认同步币种生成币种标签吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.syncCoinToLabel().then(({data}) => {
                        this.$message.success('同步成功！');
                        this.searchLabel();
                    });
                }).catch(() => {
                });
            },
            onFileChange(file) {
                if (!file) return;
                const {raw: originFile} = file;
                const {name, size} = originFile;
                const suffix = name.split('.').pop();
                if (!this.accept.includes(suffix)) {
                    this.$message.error(`只能上传${this.acceptStr}格式的文件`);
                    return;
                }
                this.readDataFromFile(originFile);
            },
            readDataFromFile(file) {
                const that = this;
                const reader = new FileReader();
                reader.onload = function (e) {
                    // pre-process data
                    let binary = '';
                    const bytes = new Uint8Array(e.target.result);
                    const length = bytes.byteLength;
                    for (let i = 0; i < length; i++) {
                        binary += String.fromCharCode(bytes[i]);
                    }

                    /* read workbook */
                    const wb = XLSX.read(binary, {
                        type: 'binary'
                    });

                    /* grab first sheet */
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];

                    /* generate HTML */
                    that.importData = XLSX.utils.sheet_to_json(ws);
                    that.labelDialogVisible = true;
                };
                reader.readAsArrayBuffer(file);
            },
            importLabel() {
                if (!this.importData || this.importData.length <= 0) {
                    this.$message.error("数据不能为空！");
                    return;
                }
                this.$confirm('确认导入这些数据吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    api.importLabel({labelType: this.type, dataJson: JSON.stringify(this.importData)}).then((rep) => {
                        this.loading = false;
                        this.getLabelList(this.queryParams);
                        this.labelDialogVisible = false;
                        this.$message.success(rep.data);
                    });
                }).catch(() => {
                });
            },
            clearDataTwo() {
                this.importData = [];
                this.loading = false;
            }
        },
        created() {
            this.queryParams.labelType = this.type;
            this.activeName = this.type;
            this.initData();
            this.getLabelList(this.queryParams);
        }
    }
</script>
<style type="text/css">
    .label-list-box .el-tabs__nav-wrap::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 2px;
        background-color: rgba(245, 249, 255, 0);
        z-index: 1;
    }
</style>
<style lang="less" scoped>
    .label-list-box {

        .label-list {
            border: 1px solid #f2ece2;
            clear: both;
            width: 100%;
            .label-table {
                margin-top: 30px;
            }
        }
    }
</style>